(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-review-pdp"] && !window.DesignMode) return;
  try {
    
    var swiper =  new Swiper(".reviewSlider", {
        slidesPerView:1.3,
        spaceBetween:10,
        breakpoints:{
            768: {
                slidesPerView:5,
                spaceBetween:15,
            }
        },
        slidesOffsetBefore: 1,
        navigation: {
            nextEl: ".button-next",
            prevEl: ".button-prev",
      },
    });
    // var swiperThumbs = new Swiper(".galleryThumbs", {
    //     slidesPerView: 3,
    //     spaceBetween: 5,
    //     loop:true,
    //     breakpoints:{
    //         768: {
    //             slidesPerView: 10,
    //             spaceBetween: 10,
    //         }
    //     },
    // });
    // var swiperGallery =  new Swiper(".gallerySlider", {
    //     slidesPerView:1,
    //     hashNavigation: {
    //         watchState: true,
    //     },
    //     navigation: {
    //         nextEl: ".swiper-button-next",
    //         prevEl: ".swiper-button-prev",
    //     },
    //     thumbs: {
    //         swiper: swiperThumbs,
    //     },
    // })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["centered_button"] && !window.DesignMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', function() {
    const cartCountElements = document.querySelectorAll('.centered-cart-count');
    const localStorageKey = 'centeredCartCount';
    const today = new Date().toDateString();
    let cartCount;

    // Check if we have a stored count for today
    if (localStorage.getItem(localStorageKey) && localStorage.getItem('centeredCartDate') === today) {
        cartCount = parseInt(localStorage.getItem(localStorageKey));
    } else {
        // Generate a new random count between 21 and 40
        cartCount = Math.floor(Math.random() * (40 - 21 + 1)) + 21;
        // Store the count and date
        localStorage.setItem(localStorageKey, cartCount.toString());
        localStorage.setItem('centeredCartDate', today);
    }

    // Ensure the count is at least 21
    cartCount = Math.max(cartCount, 21);

    // Set the same count for all instances
    cartCountElements.forEach(element => {
        element.textContent = cartCount;
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-two-column"] && !window.DesignMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const cartCountElements = document.querySelectorAll('.centered-cart-count');
  const localStorageKey = 'centeredCartCount';
  const today = new Date().toDateString();
  let cartCount;

  // Check if we have a stored count for today
  if (localStorage.getItem(localStorageKey) && localStorage.getItem('centeredCartDate') === today) {
    cartCount = parseInt(localStorage.getItem(localStorageKey));
  } else {
    // Generate a new random count between 21 and 40
    cartCount = Math.floor(Math.random() * (40 - 21 + 1)) + 21;
    // Store the count and date
    localStorage.setItem(localStorageKey, cartCount.toString());
    localStorage.setItem('centeredCartDate', today);
  }

  // Ensure the count is at least 21
  cartCount = Math.max(cartCount, 21);

  // Set the same count for all instances
  cartCountElements.forEach(element => {
    element.textContent = cartCount;
  });
});
    document.addEventListener('DOMContentLoaded', function() {
      const galleries = document.querySelectorAll('.image-gallery');

      galleries.forEach(gallery => {
        const mainItems = gallery.querySelectorAll('.image-gallery__main-item');
        const thumbItems = gallery.querySelectorAll('.image-gallery__thumb-item');
        const prevBtn = gallery.querySelector('.image-gallery__nav--prev');
        const nextBtn = gallery.querySelector('.image-gallery__nav--next');
        let currentIndex = 0;

        function showImage(index) {
          mainItems[currentIndex].classList.remove('active');
          thumbItems[currentIndex].classList.remove('active');
          currentIndex = index;
          mainItems[currentIndex].classList.add('active');
          thumbItems[currentIndex].classList.add('active');
        }

        prevBtn.addEventListener('click', () => {
          let index = currentIndex - 1;
          if (index < 0) index = mainItems.length - 1;
          showImage(index);
        });

        nextBtn.addEventListener('click', () => {
          let index = currentIndex + 1;
          if (index >= mainItems.length) index = 0;
          showImage(index);
        });

        thumbItems.forEach((thumb, index) => {
          thumb.addEventListener('click', () => showImage(index));
        });
      });
    });

      document.addEventListener('DOMContentLoaded', function() {
  const sellingFastBanners = document.querySelectorAll('.selling-fast-banner');
  
  sellingFastBanners.forEach(banner => {
    const countElement = banner.querySelector('.selling-fast-banner__count');
    const bannerId = banner.dataset.sellingFastId;
    
    if (countElement) {
      const min = parseInt(countElement.dataset.min);
      const max = parseInt(countElement.dataset.max);
      const today = new Date().toDateString();
      let count;

      const localStorageKey = `sellingFastCount_${bannerId}`;
      const localStorageDateKey = `sellingFastDate_${bannerId}`;

      // Check if we have a stored count for today
      if (localStorage.getItem(localStorageKey) && localStorage.getItem(localStorageDateKey) === today) {
        count = localStorage.getItem(localStorageKey);
      } else {
        // Generate a new random count
        count = Math.floor(Math.random() * (max - min + 1)) + min;
        // Store the count and date
        localStorage.setItem(localStorageKey, count);
        localStorage.setItem(localStorageDateKey, today);
      }

      countElement.textContent = count;
    }
  });
});

  document.addEventListener('DOMContentLoaded', function() {
    const dynamicDateElements = document.querySelectorAll('.dynamic-date');

    function getNextBusinessDay(date, daysToAdd) {
      const dayOfWeek = date.getDay();
      let daysRemaining = daysToAdd;

      while (daysRemaining > 0) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) {
          daysRemaining--;
        }
      }

      return date;
    }

    function formatDate(date) {
      const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    }

    const today = new Date();
    const shipDate = getNextBusinessDay(today, 2);
    const formattedDate = formatDate(shipDate);

    dynamicDateElements.forEach(element => {
      element.textContent = formattedDate;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-slider"] && !window.DesignMode) return;
  try {
    

var swiper = new Swiper(".logoSwiper", {
      spaceBetween: 10,
      slidesPerView: 1,
      breakpoints:{
        767:{
            slidesPerView: 5,
        }
      },
      freeMode: true,
      watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".copySwiper", {
      loop: true,
      autoplay: {
        delay:4000
      },
      slidesPerView: 1,
      spaceBetween: 70,
      thumbs: {
        swiper: swiper,
      },
      breakpoints:{
        767:{
            slidesPerView: 3,
            loop:true,
        }
      },
      pagination: {
        el: '.swiper-pagination-custom',
        type: 'bullets',
        clickable: true
      },
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-reviews"] && !window.DesignMode) return;
  try {
    

const reviewSwiper = new Swiper(".reviewSwiper", {
    spaceBetween: 10,
    pagination: {
        el: '.swiper-pagination-custom',
        type: 'bullets',
        clickable: true
    },
    navigation: {
        nextEl: ".swiper-button-next-custom",
        prevEl: ".swiper-button-prev-custom",
    },
    // autoplay: {
    //     delay: 5000,
    // },
    loop: true,
    slidesPerView: 1,
    breakpoints:{
        768: {
            slidesPerView: 4
        }
    }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !window.DesignMode) return;
  try {
    
  var swiper = new Swiper(".logoSwiper", {
    spaceBetween: 10,
    slidesPerView: 1,
    breakpoints: {
      767: {
        slidesPerView: 5,
      },
    },
    freeMode: true,
    watchSlidesProgress: true,
  });

  var swiper2 = new Swiper(".copySwiper", {
    loop: true,
    autoplay: {
      delay: 4000,
    },
    slidesPerView: 1,
    spaceBetween: 70,
    thumbs: {
      swiper: swiper,
    },
    breakpoints: {
      767: {
        slidesPerView: 3,
      },
    },
    pagination: {
      el: ".swiper-pagination-custom",
      type: "bullets",
      clickable: true,
    },
  });

  } catch(e) { console.error(e); }
})();
})();
